import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomRouteReuseStrategy implements RouteReuseStrategy {
  /** Determines if this route (and its subtree) should be detached to be reused later */
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    // Prevent detaching routes
    return false;
  } 
  /**
   * Stores the detached route.
   * Storing a `null` value should erase the previously stored value.
   */
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null): void {
    // No route storage logic
  }

  /**
   * Determines if this route (and its subtree) should be reattached.
   */
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    // Prevent attaching stored routes
    return false;
  }

  /**
   * Retrieves the previously stored route.
   */
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    // No route retrieval logic
    return null;
  }

  /**
   * Determines if a route should be reused.
   */
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    // Always return false to prevent route reuse
    return false;
  }
}